<template>
  <div class="fixed-container">
<!--     <el-button class="shbutton" type="primary" round size="small" @click="shClick">历史水毁</el-button>-->
    <el-select v-model="queryval" clearable filterable remote reserve-keyword placeholder="输入坝名关键字搜索"
      :remote-method="remoteMethod" :loading="loading" loading-text="加载中" @change="remoteChange">
      <el-option v-for="item in treedata" :key="item.ydbCode"
        :label="item.ydbName+'('+item.ydbXian+'-'+item.ydbXiang+'-'+item.ydbCun+')'"
        :value="item.ydbCode">
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import {
    selectYdbInfo
  } from '@/api/api.js'
  export default {
    data() {
      return {
        queryval: '',
        reginCode: '',
        treedata: [],

        loading: false,

        // defaultProps: {
        //   children: 'children',
        //   label: 'ydbName',
        // },
        // treeShow: false,
      }
    },
    mounted() {},
    computed: {
      nowxingzhengCodes() {
        return this.$store.state.nowxingzhengCode; //需要监听的数据
      },
    },
    watch: {
      nowxingzhengCodes(newVal, oldVal) {
        // console.log(newVal)
        this.reginCode = newVal;
      },
      $route(to, from) {
        if (this.queryval != '') {
          this.queryval = '';
          this.$emit("queryDatas", this.queryval);
        }
        // this.$store.commit('queryData', this.queryval); //token
      },
    },
    methods: {
      shClick() {
        this.$router.replace("HistoricalWaterDestruction");
      },
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          let params = {
            allowPage: false,
            ydbCode: this.reginCode,
            ydbName: query
          };
          selectYdbInfo(params).then(res => {
            // console.log('后台列表树--->', res.data)
            this.treedata = res.data;
            this.loading = false;
          })
        } else {
          this.treedata = [];
        }
      },
      remoteChange(value) {
        if (value) {
          // console.log(value)
          let data;
          for (let i = 0; i < this.treedata.length; i++) {
            if (this.treedata[i].ydbCode == value) {
              data = this.treedata[i];
            }
          }
          this.$emit("queryDatas", data);
          this.$store.commit('queryData', data); //token
          this.treedata = [];
          this.$store.commit('setInSingleEchartsShow', false)
        }
      },
    },
  }
</script>

<style scoped>
  /* .totalPie {
    width: 100%;
    max-height: 500px;
    z-index: 2;
  } */

  .fixed-container {
    position: fixed;
  }

  .shbutton {
    float: left;
    width: 30%;
  }

  >>>.el-input__inner {
    height: 40px;
    line-height: 40px;
    background: transparent;
    border: 0;
    color: #ffff;
    padding-left: 30px;
    font-size: 14px;
  }

  >>>.el-select {
    float: right;
    width: 65%;
    background: url(../../common/images/search.png) no-repeat center;
    background-size: 100% 100%;
  }

  >>>.el-select__input {
    color: #fff;
  }

  >>>.el-input--suffix .el-input__inner {
    color: #fff !important;
    background: transparent;
  }
</style>
